import common from '@/client/modules/common'
function getClientInstallTime () {
  const errorNum = 1000001
  return common.API.client_install_time().then(e => {
    const current_time = new Date()
    const install_time = e?.ProductInstallTime || 0
    if (!install_time) {
      return {
        install_time_sec: errorNum,
        install_days: 0
      }
    }
    // 将时间戳转换为日期对象
    const start_time = new Date(install_time * 1000)
    // 计算两个日期的时间差（单位为毫秒）
    const diffTime = Math.abs(current_time - start_time)
    // 计算时间差对应的天数
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    return {
      install_time_sec: +install_time, // 安装时间
      // 如果是同一天，返回1；如果不是同一天，返回计算出的天数加1
      install_days: start_time.toDateString() === current_time.toDateString() ? 1 : diffDays + 1 // 安装天数
    }
  }).catch(() => {
    return {
      install_time_sec: errorNum,
      install_days: 0
    }
  })
}

export default getClientInstallTime
